export class Card {
  first_name: string;
  last_name: string;
  card_number: string;
  expiry_month: string;
  expiry_year: string;
  cvc: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Payment/Model/card.ts